function parseCountdownDateTime(value) {
  return window.JamesOroPromotionWindow.parse(value);
}
function isValidTimeZone(timeZone) {
  try { Intl.DateTimeFormat('en-US', { timeZone }).format(); return true; }
  catch (_) { return false; }
}
function zonedDateTimeToUtcTimestamp(parts, timeZone) {
  return window.JamesOroPromotionWindow.timestamp(parts, timeZone);
}

function updateCountdownDigits(container, timeRemainingMs) {
  const totalSeconds = Math.max(0, Math.floor(timeRemainingMs / 1000));
  const days = Math.floor(totalSeconds / 86400);
  const hours = Math.floor((totalSeconds % 86400) / 3600);
  const minutes = Math.floor((totalSeconds % 3600) / 60);
  const seconds = totalSeconds % 60;

  const values = {
    days: String(days).padStart(2, '0'),
    hours: String(hours).padStart(2, '0'),
    minutes: String(minutes).padStart(2, '0'),
    seconds: String(seconds).padStart(2, '0')
  };

  Object.keys(values).forEach((key) => {
    const part = container.querySelector(`[data-countdown-part="${key}"] span`);
    if (!part) return;
    part.textContent = values[key];
    part.style.transform = 'translateY(0%)';
  });
}

function clearCountdownIntervals(container) {
  if (!container) return;
  if (container.__countdownInterval) {
    clearInterval(container.__countdownInterval);
    container.__countdownInterval = null;
  }
  if (container.__countdownIntervalFast) {
    clearInterval(container.__countdownIntervalFast);
    container.__countdownIntervalFast = null;
  }
  if (container.__countdownBounceTimeout) {
    clearTimeout(container.__countdownBounceTimeout);
    container.__countdownBounceTimeout = null;
  }
}

function clearAllCountdownIntervals() {
  if (!window.__cartDrawerCountdownContainers) return;
  window.__cartDrawerCountdownContainers.forEach((container) => clearCountdownIntervals(container));
  window.__cartDrawerCountdownContainers = [];
}

function initSingleCartDrawerCountdownLegacy(container) {
  if (!container) return;

  clearCountdownIntervals(container);

  const rawStart = container.dataset.countdownStart;
  const rawEnd = container.dataset.countdownEnd;
  const rawTimeZone = container.dataset.countdownTimezone || 'UTC';
  const hideExpired = container.dataset.countdownHideExpired !== 'false';
  const timeZone = rawTimeZone;

  const startParts = parseCountdownDateTime(rawStart);
  const endParts = parseCountdownDateTime(rawEnd);
  if (!startParts || !endParts || !isValidTimeZone(timeZone)) {
    container.classList.add('hidden');
    return;
  }

  const startTimestamp = zonedDateTimeToUtcTimestamp(startParts, timeZone);
  const endTimestamp = zonedDateTimeToUtcTimestamp(endParts, timeZone);
  if (startTimestamp === null || endTimestamp === null || !Number.isFinite(startTimestamp) || !Number.isFinite(endTimestamp) || endTimestamp <= startTimestamp) {
    container.classList.add('hidden');
    return;
  }

  const tick = () => {
    const now = Date.now();

    if (now < startTimestamp) {
      container.classList.add('hidden');
      return;
    }

    if (now >= endTimestamp) {
      updateCountdownDigits(container, 0);
      container.classList.toggle('hidden', hideExpired);
      clearCountdownIntervals(container);
      return;
    }

    container.classList.remove('hidden');
    updateCountdownDigits(container, endTimestamp - now);
  };

  container.__countdownInterval = setInterval(tick, 1000);
  tick();
}

function updateLotteryDigits(topEl, timeRemainingMs) {
  const totalSeconds = Math.max(0, Math.floor(timeRemainingMs / 1000));
  const hours = Math.floor(totalSeconds / 3600);
  const minutes = Math.floor((totalSeconds % 3600) / 60);
  const seconds = totalSeconds % 60;

  const hrText = hours >= 100 ? String(hours) : String(hours).padStart(2, '0');
  const minText = String(minutes).padStart(2, '0');
  const secText = String(seconds).padStart(2, '0');

  const hrSpan = topEl.querySelector('[data-countdown-lottery-part="hr"] span');
  const minSpan = topEl.querySelector('[data-countdown-lottery-part="min"] span');
  const secSpan = topEl.querySelector('[data-countdown-lottery-part="sec"] span');

  if (hrSpan) hrSpan.textContent = hrText;
  if (minSpan) minSpan.textContent = minText;
  if (secSpan) secSpan.textContent = secText;

  return { secText };
}

/** Keep stable event markup so a pre-start page can activate without a reload. */
function flattenCartDrawerLotteryLayout(host) {
  if (!host || !host.classList.contains('cart-drawer-items--lottery-layout')) return;
  host.classList.remove('cart-drawer-items--lottery-layout');
}

function initSingleCartDrawerCountdownLottery(topEl) {
  if (!topEl) return;

  clearCountdownIntervals(topEl);

  const bottomEl = topEl.parentElement && topEl.parentElement.querySelector('[data-countdown-lottery-bottom]');
  const host = topEl.closest('cart-drawer-items');
  const drawer = topEl.closest('cart-drawer');
  const inner = topEl.closest('.drawer__inner');

  // Never run lottery mode for empty carts.
  if ((drawer && drawer.classList.contains('is-empty')) || (host && host.classList.contains('is-empty'))) {
    topEl.classList.add('hidden');
    if (bottomEl) bottomEl.classList.add('hidden');
    if (host) host.classList.remove('cart-drawer-items--lottery-active');
    if (inner) inner.classList.remove('drawer__inner--lottery');
    return;
  }

  const rawStart = topEl.dataset.countdownStart;
  const rawEnd = topEl.dataset.countdownEnd;
  const rawTimeZone = topEl.dataset.countdownTimezone || 'UTC';
  const hideExpired = topEl.dataset.countdownHideExpired !== 'false';
  const timeZone = rawTimeZone;

  const startParts = parseCountdownDateTime(rawStart);
  const endParts = parseCountdownDateTime(rawEnd);
  if (!startParts || !endParts || !isValidTimeZone(timeZone)) {
    topEl.classList.add('hidden');
    if (bottomEl) bottomEl.classList.add('hidden');
    if (host) { host.classList.remove('cart-drawer-items--lottery-active'); flattenCartDrawerLotteryLayout(host); }
    if (inner) inner.classList.remove('drawer__inner--lottery');
    return;
  }

  const startTimestamp = zonedDateTimeToUtcTimestamp(startParts, timeZone);
  const endTimestamp = zonedDateTimeToUtcTimestamp(endParts, timeZone);
  if (startTimestamp === null || endTimestamp === null || !Number.isFinite(startTimestamp) || !Number.isFinite(endTimestamp) || endTimestamp <= startTimestamp) {
    topEl.classList.add('hidden');
    if (bottomEl) bottomEl.classList.add('hidden');
    if (host) { host.classList.remove('cart-drawer-items--lottery-active'); flattenCartDrawerLotteryLayout(host); }
    if (inner) inner.classList.remove('drawer__inner--lottery');
    return;
  }

  const setVisible = (isVisible) => {
    if (isVisible) {
      topEl.classList.remove('hidden');
      if (bottomEl) bottomEl.classList.remove('hidden');
      if (host) host.classList.add('cart-drawer-items--lottery-active', 'cart-drawer-items--lottery-layout');
      if (inner) inner.classList.add('drawer__inner--lottery');
      return;
    }
    topEl.classList.add('hidden');
    if (bottomEl) bottomEl.classList.add('hidden');
    if (host) host.classList.remove('cart-drawer-items--lottery-active');
    if (inner) inner.classList.remove('drawer__inner--lottery');
  };

  let lastSecText = null;

  const tick = () => {
    const now = Date.now();

    if (now < startTimestamp) {
      setVisible(false);
      flattenCartDrawerLotteryLayout(host);
      updateLotteryDigits(topEl, 0);
      return;
    }

    if (now >= endTimestamp) {
      updateLotteryDigits(topEl, 0);
      // Always tear down lottery chrome when the window ends so qty/GWP/upsell
      // layout can't stick in lottery shell after the event (or after unchecking).
      setVisible(false);
      flattenCartDrawerLotteryLayout(host);
      clearCountdownIntervals(topEl);
      return;
    }

    const remainingMs = endTimestamp - now;
    const { secText } = updateLotteryDigits(topEl, remainingMs);

    if (secText && secText !== lastSecText) {
      lastSecText = secText;
      const secDigit = topEl.querySelector('[data-countdown-lottery-part="sec"]');
      if (secDigit) {
        secDigit.classList.remove('is-bounce');
        void secDigit.offsetWidth;
        secDigit.classList.add('is-bounce');
        if (topEl.__countdownBounceTimeout) clearTimeout(topEl.__countdownBounceTimeout);
        topEl.__countdownBounceTimeout = setTimeout(() => secDigit.classList.remove('is-bounce'), 300);
      }
    }

    setVisible(true);
  };

  setVisible(false);
  updateLotteryDigits(topEl, 0);
  topEl.__countdownInterval = setInterval(tick, 1000);
  tick();
}

function initCartDrawerCountdown() {
  clearAllCountdownIntervals();
  window.__cartDrawerCountdownContainers = [];

  // Safety: never show lottery layout on empty carts.
  document.querySelectorAll('cart-drawer').forEach((drawer) => {
    const host = drawer.querySelector('cart-drawer-items');
    const isEmptyDrawer = drawer.classList.contains('is-empty');
    const isEmptyHost = host && host.classList.contains('is-empty');
    const hasLineItems = !!drawer.querySelector('#CartDrawer-CartItems .cart-item');
    const isEmpty = isEmptyDrawer || isEmptyHost || !hasLineItems;

    if (!isEmpty) return;

    const inner = drawer.querySelector('.drawer__inner');
    if (inner) inner.classList.remove('drawer__inner--lottery');
    if (host) {
      flattenCartDrawerLotteryLayout(host);
      host.classList.remove('cart-drawer-items--lottery-active');
    }
    drawer.querySelectorAll('[data-countdown-mode="lottery"], [data-countdown-lottery-bottom]').forEach((el) => {
      el.classList.add('hidden');
    });
  });

  document.querySelectorAll('[data-cart-drawer-countdown]').forEach((container) => {
    const mode = container.dataset.countdownMode || 'legacy';
    window.__cartDrawerCountdownContainers.push(container);

    if (mode === 'lottery') {
      const host = container.closest('cart-drawer-items');
      const drawer = container.closest('cart-drawer');
      const inner = container.closest('.drawer__inner');
      const bottomEl = host && host.querySelector('[data-countdown-lottery-bottom]');
      const isEmpty = (drawer && drawer.classList.contains('is-empty')) || (host && host.classList.contains('is-empty'));

      if (isEmpty) {
        container.classList.add('hidden');
        if (bottomEl) bottomEl.classList.add('hidden');
        if (host) host.classList.remove('cart-drawer-items--lottery-active');
        if (inner) inner.classList.remove('drawer__inner--lottery');
        return;
      }

      initSingleCartDrawerCountdownLottery(container);
      return;
    }

    initSingleCartDrawerCountdownLegacy(container);
  });
}

class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
    this.setHeaderCartIconAccessibility();
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(cartLink)
    });
    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
    
    setTimeout(() => { this.classList.add('animate', 'active') });

    document.body.classList.add('overflow-hidden');

    this.addEventListener('transitionend', () => {
      // The empty state shares the header and footer, so trap focus on the whole drawer either way.
      const containerToTrapFocusOn = document.getElementById('CartDrawer');
      const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
      trapFocus(containerToTrapFocusOn, focusElement);
    }, { once: true });

    // Same pattern as GWP: re-evaluate BOGO prompt whenever the drawer opens (not only on ATC).
    if (typeof window.updateBogoCartPrompt === 'function') {
      window.updateBogoCartPrompt(false);
    }
    if (typeof initCartDrawerUpsellNav === 'function') {
      initCartDrawerUpsellNav(this);
    }
  }



  close() {
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if(cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  renderContents(parsedState) {
    const drawerInner = this.querySelector('.drawer__inner');
    if (drawerInner && drawerInner.classList.contains('is-empty')) {
      drawerInner.classList.remove('is-empty');
    }

    this.productId = parsedState.id;

    this.getSectionsToRender().forEach((section => {
      const sectionElement = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id);
      const sectionHtml = parsedState.sections[section.id];

      if (!sectionElement || !sectionHtml) return;
      sectionElement.innerHTML = this.getSectionInnerHTML(sectionHtml, section.selector);
    }));

    setTimeout(() => {
    const overlay = this.querySelector('#CartDrawer-Overlay');
    if (overlay) {
      overlay.addEventListener('click', this.close.bind(this));
    }
    this.open();
    initCartDrawerCountdown();
    if (typeof initCartDrawerUpsellNav === 'function') {
      initCartDrawerUpsellNav(this);
    }

    // ✅ Wait a moment before fetching cart to ensure sections are fully re-rendered
    setTimeout(() => {
      fetch('/cart.js')
        .then(res => res.json())
        .then(cart => {
          if (typeof updateGiftProgressBar === 'function') {
            updateGiftProgressBar(cart);
          }
          if (typeof window.updateBogoCartPrompt === 'function') {
            window.updateBogoCartPrompt(false);
          }
        })
        .catch(() => {});
    }, 250); // Give time for prices + DOM to reflect
  });


  }




  getSectionInnerHTML(html, selector = '.shopify-section') {
    if (!html) return '';
    const parsed = new DOMParser().parseFromString(html, 'text/html');
    const target = parsed.querySelector(selector);
    if (target) return target.innerHTML;

    const fallback = parsed.querySelector('.shopify-section');
    if (fallback) return fallback.innerHTML;

    return parsed.body ? parsed.body.innerHTML : '';
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer'
      },
      {
        id: 'cart-icon-bubble'
      }
    ];
    console.log('22');
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
  async onCartUpdate(event) {
    // The guard has already redrawn the whole drawer from a verified cart.
    if (event?.source === 'gift-cart-guard') return;
    const revision = this.cartRefreshRevision = (this.cartRefreshRevision || 0) + 1;
    try {
      const response = await fetch(`${window.Shopify.routes.root}?section_id=cart-drawer`, { cache: 'no-store' });
      if (!response.ok) return;
      const html = new DOMParser().parseFromString(await response.text(), 'text/html');
      if (!this.isConnected || revision !== this.cartRefreshRevision) return;
      const drawer = this.closest('cart-drawer');
      const source = html.querySelector('cart-drawer .drawer__inner');
      const destination = drawer?.querySelector('.drawer__inner');
      if (!source || !destination) return;
      destination.innerHTML = source.innerHTML;
      drawer.classList.toggle('is-empty', html.querySelector('cart-drawer').classList.contains('is-empty'));
      drawer.querySelector('#CartDrawer-Overlay')?.addEventListener('click', () => drawer.close());
      initCartDrawerCountdown();
      if (typeof initCartDrawerUpsellNav === 'function') initCartDrawerUpsellNav(drawer);
      if (typeof fetchCartAndUpdateProgress === 'function') fetchCartAndUpdateProgress(false);
    } catch (_) { /* Preserve the existing drawer on a failed background refresh. */ }
  }

  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner'
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section'
      }
    ];
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);

document.addEventListener('DOMContentLoaded', initCartDrawerCountdown);

function getUpsellScrollStep(list) {
  const first = list.querySelector('.cart-drawer-upsell');
  if (!first) return 160;
  const styles = window.getComputedStyle(list);
  const gap = parseFloat(styles.columnGap || styles.gap) || 12;
  return first.getBoundingClientRect().width + gap;
}

function syncCartDrawerUpsellNav(scope) {
  const root = scope || document;
  const list = root.querySelector('[data-cart-drawer-upsells-list]');
  const prev = root.querySelector('[data-cart-drawer-upsells-prev]');
  const next = root.querySelector('[data-cart-drawer-upsells-next]');
  if (!list || !prev || !next) return;

  const maxScroll = Math.max(0, list.scrollWidth - list.clientWidth);
  const atStart = list.scrollLeft <= 2;
  const atEnd = list.scrollLeft >= maxScroll - 2;
  const canScroll = maxScroll > 2;

  prev.disabled = !canScroll || atStart;
  next.disabled = !canScroll || atEnd;
}

function initCartDrawerUpsellNav(scope) {
  const root = scope || document;
  root.querySelectorAll('[data-cart-drawer-upsells-nav]').forEach((nav) => {
    const host = nav.closest('.drawer__inner') || nav.closest('cart-drawer') || document;
    const list = host.querySelector('[data-cart-drawer-upsells-list]');
    if (!list) return;

    if (nav.dataset.upsellNavBound === 'true') {
      syncCartDrawerUpsellNav(host);
      return;
    }
    nav.dataset.upsellNavBound = 'true';

    const prev = nav.querySelector('[data-cart-drawer-upsells-prev]');
    const next = nav.querySelector('[data-cart-drawer-upsells-next]');
    const sync = () => syncCartDrawerUpsellNav(host);

    prev?.addEventListener('click', () => {
      list.scrollBy({ left: -getUpsellScrollStep(list), behavior: 'smooth' });
    });
    next?.addEventListener('click', () => {
      list.scrollBy({ left: getUpsellScrollStep(list), behavior: 'smooth' });
    });
    list.addEventListener('scroll', sync, { passive: true });
    window.addEventListener('resize', sync);
    // Wait a frame so scrollWidth is accurate after drawer paint.
    requestAnimationFrame(sync);
  });
}

document.addEventListener('DOMContentLoaded', () => initCartDrawerUpsellNav());
window.initCartDrawerUpsellNav = initCartDrawerUpsellNav;

/**
 * Direct upsell ATC for single-SKU products (no colorway family / modal).
 * Avoids product-form + display:contents, which can fall through to a native
 * /cart/add POST and land on the cart page.
 */
document.addEventListener('click', async (event) => {
  const btn = event.target.closest('[data-cart-drawer-upsell-add]');
  if (!btn) return;

  event.preventDefault();
  event.stopPropagation();
  if (btn.getAttribute('aria-disabled') === 'true') return;

  const variantId = btn.getAttribute('data-variant-id');
  if (!variantId) return;
  const analytics = window.CaffeineOfferAnalytics;
  const analyticsFields = {
    ...(analytics?.fieldsFromElement(btn) || {}),
    variantId,
    role: 'recommendation'
  };
  const offerInstanceId = window.crypto?.randomUUID
    ? window.crypto.randomUUID()
    : `${Date.now().toString(36)}-${Math.random().toString(36).slice(2)}`;
  analyticsFields.offerInstanceId = offerInstanceId;
  analytics?.track('add_attempt', analyticsFields);

  const cart = document.querySelector('cart-drawer');
  const spinner = btn.querySelector('.loading-overlay__spinner');

  btn.setAttribute('aria-disabled', 'true');
  btn.classList.add('loading');
  if (spinner) spinner.classList.remove('hidden');

  try {
    const sectionIds =
      cart && typeof cart.getSectionsToRender === 'function'
        ? cart.getSectionsToRender().map((section) => section.id)
        : ['cart-drawer', 'cart-icon-bubble'];

    const response = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify({
        items: [
          {
            id: Number(variantId),
            quantity: 1,
            properties: {
              _caffeine_offer_type: 'cart_upsell',
              _caffeine_offer: analyticsFields.offerId || 'cross-sell-cart',
              _caffeine_instance: offerInstanceId,
              _caffeine_role: 'recommendation',
              _caffeine_placement: 'cart_drawer',
              _caffeine_sid: analytics?.sessionId || ''
            },
          },
        ],
        sections: sectionIds.join(','),
        sections_url: window.location.pathname,
      }),
    });

    const result = await response.json();
    if (!response.ok) {
      throw new Error(result.description || result.message || 'Unable to add to cart');
    }

    if (cart && typeof cart.renderContents === 'function') {
      cart.classList.remove('is-empty');
      if (result.sections) {
        cart.renderContents(result);
      } else {
        const sections = await fetch(
          `/?sections=${sectionIds.join(',')}`
        ).then((res) => res.json());
        cart.renderContents({ sections, id: Number(variantId) });
      }
    }

    if (typeof window.updateBogoCartPrompt === 'function') {
      window.updateBogoCartPrompt(true);
    }
    analytics?.track('conversion', analyticsFields);
    analytics?.observe(document);
  } catch (err) {
    analytics?.track('add_error', {
      ...analyticsFields,
      detail: { message: String(err?.message || 'add failed').slice(0, 200) }
    });
    console.error('[cart-drawer-upsell]', err);
    alert(err.message || 'Unable to add to cart. Please try again.');
  } finally {
    btn.classList.remove('loading');
    btn.removeAttribute('aria-disabled');
    if (spinner) spinner.classList.add('hidden');
  }
});
